import { render, staticRenderFns } from "./SimpleDefaultView.vue?vue&type=template&id=156cc591&scoped=true"
import script from "./SimpleDefaultView.vue?vue&type=script&lang=js"
export * from "./SimpleDefaultView.vue?vue&type=script&lang=js"
import style0 from "./SimpleDefaultView.vue?vue&type=style&index=0&id=156cc591&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cc591",
  null
  
)

export default component.exports